
const ChatHistorySkeletonLoader = () => (
  <div className="px-1 pt-2 mt-2 border-t border-gray-200 dark:border-gray-700 space-y-0">
    {[...Array(20)].map((_, index) => (
      <div key={index} className="px-2 py-2 ">
        <div className="animate-pulse">
          <div className="h-6 bg-gray-200 dark:bg-gray-700 rounded w-[100%] mb-0"/>
        </div>
      </div>
    ))}
  </div>
);

export default ChatHistorySkeletonLoader;